export default "__VITE_ASSET__CunNYweO__"